import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { sortBy } from 'lib/array/arrayUtils'

interface FlightDealAvailabilityCtaParams {
  isOfferPage: boolean
  checkInDate?: string
  checkOutDate?: string
  duration?: number
  travelPeriods?: Array<App.FlightDealTravelPeriod>
}

function getSelectedCheckOutDate(checkInDate: string, checkOutDate?: string, duration?: number): string | undefined {
  if (checkOutDate) return checkOutDate
  if (!duration) return undefined
  return moment(checkInDate).add(duration, 'days').format(ISO_DATE_FORMAT)
}

function selectedDatesMatchTravelPeriods(checkInDate: string, checkOutDate: string, travelPeriods: Array<App.FlightDealTravelPeriod> = []): boolean {
  return travelPeriods.some((period) => {
    const departureDate = moment.utc(period.departureDate).format(ISO_DATE_FORMAT)
    const arrivalDate = moment.utc(period.arrivalDate).format(ISO_DATE_FORMAT)

    return checkInDate >= departureDate && checkOutDate <= arrivalDate
  })
}

export function getFlightDealForStay(deals: Array<App.FlightDeal>, checkInDate?: string, duration?: number): App.FlightDeal | undefined {
  const checkOutDate = checkInDate ? getSelectedCheckOutDate(checkInDate, undefined, duration) : undefined
  const eligibleDeals = checkInDate && checkOutDate
    ? deals.filter(deal => selectedDatesMatchTravelPeriods(checkInDate, checkOutDate, deal.travelPeriods))
    : deals

  return sortBy(eligibleDeals, deal => deal.perAdultPrice, 'asc')[0]
}

export function shouldShowFlightDealAvailabilityCta(params: FlightDealAvailabilityCtaParams): boolean {
  const { isOfferPage, checkInDate, checkOutDate, duration, travelPeriods } = params

  if (!isOfferPage) return false
  if (!checkInDate) return true

  const selectedCheckOutDate = getSelectedCheckOutDate(checkInDate, checkOutDate, duration)
  if (!selectedCheckOutDate) return true

  return !selectedDatesMatchTravelPeriods(checkInDate, selectedCheckOutDate, travelPeriods)
}
